var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('u-tabs-dot', _vm._b({
    staticClass: "v-tabs--border",
    on: {
      "change": _vm.TabsTertiaryValueChange
    },
    scopedSlots: _vm._u([_vm._l(_vm.$slots, function (_, slotName) {
      return {
        key: slotName,
        fn: function () {
          return [_vm._t(slotName)];
        },
        proxy: true
      };
    })], null, true),
    model: {
      value: _vm.TabsTertiaryValue,
      callback: function ($$v) {
        _vm.TabsTertiaryValue = $$v;
      },
      expression: "TabsTertiaryValue"
    }
  }, 'u-tabs-dot', _vm.$attrs, false));

}
var staticRenderFns = []

export { render, staticRenderFns }